module.exports = __webpack_public_path__ + "static/media/YF11_4.35622407.jpg";